<script setup>

import { defineProps, defineEmits, watch, ref, computed} from "vue";
import BarraNavegacao from "./BarraNavegacao.vue";
import DadoConteudo from "./DadoConteudo.vue";
import UtilObject from "@/utils/UtilObject";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "usuarioStore",
    "colaboradorStore",
    "modalStatus",
    "recarregaDados",
    "controlesDesativados",
    "dadoOriginal",
]);

const emits = defineEmits([
    "update:alteraModal",
    "update:alteraRecarregaDados",
    "update:alteraControlesDesativados",
]);

//==================================================================//
//===================== Criando Adiantamento =======================//
//==================================================================//

const criandoAdiantamento = ref(false);

//==================================================================//
//=============================== Dado =============================//
//==================================================================//

const dado = ref({});

//==================================================================//
//=========================== Altera Modal =========================//
//==================================================================//

const alteraModal = (update) =>{

    emits('update:alteraModal',update);

};

//==================================================================//
//=================== Altera Visualizando Job ======================//
//==================================================================//

const alteraRecarregaDados = (update) =>{

    emits('update:alteraRecarregaDados',update);

};

//==================================================================//
//================= Altera Controles Desativados ===================//
//==================================================================//

const alteraControlesDesativados = (update) =>{

    emits('update:alteraControlesDesativados',update);

};

//==================================================================//
//========================= Modal Abriu ============================//
//==================================================================//

const modalAbriu = computed(()=>{

    return props.modalStatus == true;

});

//==================================================================//
//================= Altera Criando Adiantamento ====================//
//==================================================================//

const alteraCriandoAdiantamento = (update)=>{

    criandoAdiantamento.value = update;

};

//==================================================================//
//========================== Altera Dado ===========================//
//==================================================================//

const alteraDado = (update)=>{

    dado.value = UtilObject.merge(dado.value, update);

};

//==================================================================//
//====================== Altera Parcela ============================//
//==================================================================//

const alteraParcela = (update)=>{

    let parcelas = dado?.value?.parcelas?.map((parcela)=>{

        if(parcela.id != update.id){
            return parcela
        }

        return{
            ...parcela,
            ...update
        }

    });

    alteraDado({
        parcelas: parcelas
    });

};

//==================================================================//
//======================= Altera Adiantamento ======================//
//==================================================================//

const alteraAdiantamento = (update)=>{

    let parcelas = dado?.value?.parcelas?.map((parcela)=>{

        if(parcela.id != update.parcela.id){
            return parcela
        }

        // Lista é Adiantamentos nesse caso, ele se chama assim pois é um campo partilhado.
        // Item é Nota Fiscal Emitida nesse caso, ele se chama assim pois é um campo compartilhado.
        let lista = parcela?.lista?.map((item)=>{

            if(item.id != update.adiantamento.id){
                return item
            }

            return UtilObject.merge(item,update.adiantamento);

        });

        parcela.lista = lista;

        return parcela;

    });

    alteraDado({
        parcelas: parcelas
    });

};

//==================================================================//
//===================== Prepara Adiantamento =======================//
//==================================================================//

const preparaAdiantamento = (adiantamento = {}) =>{

    let notasFiscaisEmitidas = adiantamento?.notasFiscaisEmitidas?.map((notaFiscalEmitida)=>{

        return{
            id: notaFiscalEmitida?.id || "",
            codigo: notaFiscalEmitida?.codigo || "",
            numero: notaFiscalEmitida?.numero || "",
            serie: notaFiscalEmitida?.serie || "",
            chaveAcesso: notaFiscalEmitida?.chaveAcesso || "",
            plugNotasID: notaFiscalEmitida?.plugNotasID || "",
            contaAReceberCodigo: notaFiscalEmitida?.contaAReceber?.codigo || "",
            recebimentoID: notaFiscalEmitida?.recebimento?.id || "",
            recebimentoSequencia: notaFiscalEmitida?.recebimento?.sequencia || "",
            recebimentoDataCriacao: notaFiscalEmitida?.recebimento?.dataCriacaoFormatada || "",
            recebimentoValorRecebido: notaFiscalEmitida?.recebimento?.valorRecebimento || "",
        }

    });

    let adiantamentoStatus = adiantamento?.status?.replace(/Realizada|Prevista/g, match => {
        if (match === "Realizada") return "Realizado";
        if (match === "Prevista") return "Previsto";
    });

    return {
        id: adiantamento?.id || "",
        aberto: false,
        codigo: adiantamento?.codigo || "",
        origem: adiantamento?.origem || "",
        status: adiantamentoStatus || "",
        contaFinanceiraNome: adiantamento?.contaFinanceira?.nome || "",
        valorOriginal: adiantamento?.valorOriginal || "",
        valorRecebido: adiantamento?.valorRecebido || "",
        valorParaReceber: adiantamento?.valorParaReceber || "",
        dataCriacao: adiantamento?.dataCriacaoFormatada || "",
        notasFiscaisEmitidas: notasFiscaisEmitidas || []
    };

};

//==================================================================//
//================= Prepara Nota Fiscal Emitida ====================//
//==================================================================//

const preparaNotaFiscalEmitida = (notaFiscalEmitida = {}) =>{

    return{
        id: notaFiscalEmitida?.id || "",
        codigo: notaFiscalEmitida?.codigo || "",
        numero: notaFiscalEmitida?.numero || "",
        serie: notaFiscalEmitida?.serie || "",
        chaveAcesso: notaFiscalEmitida?.chaveAcesso || "",
        plugNotasID: notaFiscalEmitida?.plugNotasID || "",
        contaAReceberCodigo: notaFiscalEmitida?.contaAReceber?.codigo || "",
        contaFinanceiraNome: notaFiscalEmitida?.contaFinanceira?.nome || "",
        recebimentoID: notaFiscalEmitida?.recebimento?.id || "",
        recebimentoSequencia: notaFiscalEmitida?.recebimento?.sequencia || "",
        recebimentoDataCriacao: notaFiscalEmitida?.recebimento?.dataCriacaoFormatada || "",
        recebimentoValorRecebido: notaFiscalEmitida?.recebimento?.valorRecebimento || "",
    }

};

//==================================================================//
//========================= Prepara Dado ===========================//
//==================================================================//

const preparaDado = (dado = {})=>{

    let parcelas = dado?.parcelas?.map((parcela)=>{

        let lista = parcela?.lista?.reduce((acc, item)=>{

            if(parcela.tipoOculto == "AD"){

                acc.push(preparaAdiantamento(item));

            }else if(parcela.tipoOculto == "NF"){

                acc.push(preparaNotaFiscalEmitida(item));

            }

            return acc;

        },[]);

        return {
            id: parcela?.id || "",
            aberto: false,
            codigo: parcela?.codigo || "",
            sequencia: parcela?.sequencia || "",
            tipoOculto: parcela?.tipoOculto || "",
            tipo: parcela?.tipo || "",
            descricao: parcela?.descricao || "",
            parcelaDias: parcela?.parcelaDias || "",
            dataVencimento: parcela?.dataVencimentoFormatada || "",
            dataPrevisao: parcela?.dataPrevisaoFormatada || "",
            parcelaPorcentagem: parcela?.parcelaPorcentagem || "",
            valorOriginal: parcela?.parcelaValor || 0,
            valorRecebido: parcela?.valorRecebido || 0,
            valorParaReceber: parcela?.valorParaReceber || 0,
            lista: lista || []
        };

    });

    dado = {
        id: dado?.id || "",
        dataUpdateUnix: dado?.dataUpdateUnix || 0,
        codigo: dado?.codigo || "",
        parcelas: parcelas || []
    }

    alteraDado(dado);

};

//==================================================================//
//======================== Prepara Modal ===========================//
//==================================================================//

const preparaModal = ()=>{

    preparaDado(UtilObject.clone(props?.dadoOriginal));

}

//==================================================================//
//======================= Watch => modalAbriu =====================//
//==================================================================//

watch((modalAbriu), (valor) => {

    if(valor == true){
        preparaModal();
    }

},{ immediate: true });

//==================================================================//
//===================== Watch => recarregaDados ====================//
//==================================================================//

watch(() => props.recarregaDados, (valorAgora, valorAntes) => {

    if(valorAntes == true && valorAgora == false){
        preparaModal();
    }

});

</script>

<template>

    <main>

        <v-dialog
            content-class="c-dialog"
            v-model="props.modalStatus"
            fullscreen
            transition="dialog-bottom-transition"
            persistent
        >

            <v-card class="c-modal">

                <BarraNavegacao
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :recarregaDados="props?.recarregaDados"
                    :controlesDesativados="props.controlesDesativados"
                    :criandoAdiantamento="criandoAdiantamento"
                    :dado="dado"
                    @update:alteraModal="alteraModal"
                ></BarraNavegacao>

                <DadoConteudo
                    :usuarioStore="props.usuarioStore"
                    :colaboradorStore="props.colaboradorStore"
                    :recarregaDados="props?.recarregaDados"
                    :controlesDesativados="props.controlesDesativados"
                    :criandoAdiantamento="criandoAdiantamento"
                    :dadoOriginal="props.dadoOriginal"
                    :dado="dado"
                    @update:alteraRecarregaDados=alteraRecarregaDados
                    @update:alteraControlesDesativados="alteraControlesDesativados"
                    @update:alteraCriandoAdiantamento="alteraCriandoAdiantamento"
                    @update:alteraParcela="alteraParcela"
                    @update:alteraAdiantamento="alteraAdiantamento"
                ></DadoConteudo>
            
            </v-card>

        </v-dialog>

    </main>

</template>

<style scoped>

.v-dialog__content >>> .v-dialog{
    background-color: white;
}

</style>

